import { useEffect, useMemo, useRef } from "react";
import useModal from "../../../hooks/useModal";
import CustomDataTable from "../../../components/CustomDataTable";
import { NumberUtil } from "../../../utils/number";
import PieChart from "../../../components/PieChart";

interface DetailCategoriesModalProps {
    show: boolean;
    data: any;
    onRequestClose: (refresh: boolean) => void;
}

function DetailCategoriesModal({ show, data, onRequestClose }: DetailCategoriesModalProps) {

    const modal = useRef<HTMLDivElement>(null);

    useModal(modal, show)

    const tipications = useMemo(() => {
        
        if(!data?.tipications) return []

        
        let tipications = data.tipications;
        let keys = Object.keys(tipications)
    
        return keys.map(k => ({ category: k, total: tipications[k]})).sort((a, b) => b.total - a.total) 
    }, [data?.tipications])
    

    return (
        <div className="modal fade" ref={modal} data-bs-backdrop="static" data-bs-keyboard="false">
            <div className="modal-dialog modal-xl" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">Categorias de cierre</h4>
                            <button type="button" className="btn-close" onClick={() => onRequestClose(false)}></button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-lg-4">
                                    <div className="card-body bg-light h-100 d-flex align-items-center justify-content-center">

                                    <PieChart
                                        datasetName='Resumen'
                                        legendDisplay={false}
                                        width={250}
                                        height={250}
                                        dataset={{
                                            labels: tipications.map( t => t.category ),
                                            data: tipications.map( t => t.total ),
                                            backgroundColor: tipications.map( t => {
                                                const randomNum = () => Math.floor(Math.random() * (235 - 52 + 1) + 52);
                                                const randomRGB = () => `rgb(${randomNum()}, ${randomNum()}, ${randomNum()})`;

                                                return randomRGB()
                                            }),
                                        }}
                                    />
                                    </div>    
                                </div>
                                <div className="col-lg-8">

                                    <div className="card-body card-body-height">
                                        <div className="table-responsive datatable-custom">
                                            <table className="table">
                                                <thead className="thead-light">
                                                    <tr>
                                                        <th>Categoría</th>
                                                        <th>Total</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        tipications.map( (t, i ) => (
                                                            <tr key={i}>
                                                                <td>{t.category}</td>
                                                                <td>{NumberUtil.format(t.total)}</td>
                                                            </tr>
                                                        ))
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="submit" className="btn btn-primary btn-sm"onClick={() => onRequestClose(false)}>Cerrar</button>
                        </div>
                    </div>
            </div>
        </div>
    )
}
export default DetailCategoriesModal